export default function cadastroModal(seletor) {
    const btnCadastro = document.getElementById(seletor || "cadastre-se");
    const modalCadastro = document.getElementById("modalCadastre-se");
    const fecharModalCadastro = document.getElementById("fechar-modal-cadastro");
    
    const footerCadastro = document.querySelector("#alfa_leiloes_footer #cadastre-se");

    if (btnCadastro) {
        btnCadastro.addEventListener("click", function (event) {
            event.preventDefault();
            modalCadastro.style.display = "block";
            document.body.classList.add("modal-open");
        });

    }

    if (fecharModalCadastro) {
        fecharModalCadastro.addEventListener("click", function () {
            modalCadastro.style.display = "none";
            document.body.classList.remove("modal-open");
        });
    }

    window.addEventListener("click", function (event) {
        if (event.target === modalCadastro) {
            modalCadastro.style.display = "none";
            document.body.classList.remove("modal-open");
        }
    });

    function abrirModalCadastro() {
        const modalCadastro = document.getElementById("modalCadastre-se");
        if (modalCadastro) {
            modalCadastro.style.display = "block";
            document.body.classList.add("modal-open");
        }
    }
    console.log(footerCadastro);
    if(footerCadastro){
        footerCadastro.addEventListener("click", abrirModalCadastro)
    }
}